var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodingAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM13.7117 9.23717C13.8427 8.84421 13.6303 8.41947 13.2374 8.28849C12.8444 8.1575 12.4197 8.36987 12.2887 8.76283L10.2887 14.7628C10.1577 15.1558 10.3701 15.5805 10.763 15.7115C11.156 15.8425 11.5807 15.6301 11.7117 15.2372L13.7117 9.23717ZM9.03373 9.86064C9.32495 9.56608 9.32225 9.09122 9.0277 8.8C8.73314 8.50877 8.25828 8.51147 7.96705 8.80603L5.79662 11.0013C5.25033 11.5538 5.25033 12.4462 5.79662 12.9987L7.96705 15.194C8.25828 15.4885 8.73314 15.4912 9.0277 15.2C9.32225 14.9088 9.32495 14.4339 9.03373 14.1394L6.91856 12L9.03373 9.86064ZM16.0335 8.80603C15.7423 8.51147 15.2674 8.50877 14.9729 8.8C14.6783 9.09122 14.6756 9.56608 14.9668 9.86064L17.082 12L14.9668 14.1394C14.6756 14.4339 14.6783 14.9088 14.9729 15.2C15.2674 15.4912 15.7423 15.4885 16.0335 15.194L18.204 12.9987C18.7502 12.4462 18.7502 11.5538 18.204 11.0013L16.0335 8.80603Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingAlt1);
export default __webpack_public_path__ + "static/media/coding-alt-1.59c3f20dcd6fefca1f9fdc1e547ae7f5.svg";
export { ForwardRef as ReactComponent };